import React, { useEffect, useState } from 'react';
import { Col, Row } from 'antd';
import { PageTitle } from '@app/components/common/PageTitle/PageTitle';
import ExportExtentionTable from '@app/components/apps/Export/ExportExtention/ExportExtentionTable';
import { BaseBreadcrumb } from '@app/components/common/BaseBreadcrumb/BaseBreadcrumb';
import { useHeader } from '@app/components/header/layouts/HeaderContext';
import { useNavigate } from 'react-router-dom';
import { BaseButton } from '@app/components/common/BaseButton/BaseButton';

const AllExportExtension: React.FC = () => {
  const { setBreadcrumb, addHeaderButton, removeHeaderButton, clearHeaderButtons } = useHeader();
  const navigate = useNavigate();

  function handleCreateClick(): void {
    navigate('/add-export-extension');
  }

  useEffect(() => {
    setBreadcrumb(
      <BaseBreadcrumb
        routes={[{ path: '/export-extensions', breadcrumbName: 'Export-Extensions' }]}
        style={{ marginBottom: '15px' }}
      />,
    );

    const user = JSON.parse(localStorage.getItem('user') || '{}');
    const isRestricted = user?.id === 4;

    if (!isRestricted) {
      addHeaderButton(
        'Add Export Extention',
        <BaseButton type="primary" size="small" onClick={handleCreateClick}>
          Create
        </BaseButton>,
      );
    }

    return () => {
      setBreadcrumb(undefined);
      clearHeaderButtons();
    };
  }, []);

  return (
    <>
      <PageTitle>Follow-Up</PageTitle>
      <Row gutter={[16, 16]}>
        <Col span={24}>
          <ExportExtentionTable />
        </Col>
      </Row>
    </>
  );
};

export default AllExportExtension;
